import {showNotification} from 'platform/components';

import {
  useGetSamochodyPlExtraLinkQuery,
  useGetSamochodyPlPlatformQuery,
  useSamochodyPlAuthenticateMutation,
} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {
  PlatformAuthenticationFormUrlExport,
  PlatformAuthenticationFormUrlExportProps,
} from './components/PlatformAuthenticationFormUrlExport';
import {PlatformPhotoSettings} from './components/PlatformPhotoSettings';

export function PlatformSettingsSamochodyPl() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isFetching, isError} = useGetSamochodyPlPlatformQuery({params});
  const {data: extraLinkData} = useGetSamochodyPlExtraLinkQuery(params);
  const [saveAuthentication] = useSamochodyPlAuthenticateMutation();

  const onSubmitCredentials: PlatformAuthenticationFormUrlExportProps['onSubmit'] = (
    values,
    _setErrors,
    reset
  ) =>
    saveAuthentication({body: values, params})
      .unwrap()
      .then(() => {
        showNotification.success(
          i18n.t('entity.advertisingPlatforms.notifications.credentialsSaved')
        );
        reset(undefined, {keepValues: true});
      })
      .catch(handleApiError);

  return (
    <>
      <PlatformAuthenticationFormUrlExport
        values={data?.credentials}
        extraLink={extraLinkData?.link}
        isFetching={isFetching}
        isError={isError}
        onSubmit={onSubmitCredentials}
        data-testid={testIds.settings.advertisingPlatforms('platformAuthenticationFormUrlExport')}
      />
      <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.SAMOCHODY_PL} />
    </>
  );
}
